import {UrlManager} from './types';

type QueryParams = {[key: string]: string};

export class DummyUrlManager implements UrlManager {
  private params: QueryParams;
  private pathname: string;

  constructor({params = {}, pathname = ``} = {}) {
    this.params = params;
    this.pathname = pathname;
  }

  getPath() {
    return this.pathname;
  }

  getQueryStringParam(paramName: string) {
    return paramName in this.params ? this.params[paramName] : null;
  }
}
